import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Icon, Table } from 'antd';
import { OperateSpan } from '../../components/Widgets';
import AuditRejectModal from '../../components/AuditManage/AuditRejectModal';
import RejectTip from '../../components/AuditManage/RejectTip';
import {
  ENGLISH,
  MEETING_AUDIT_STATUS,
  MEETING_STATUS,
  PATHS,
  ROLES_KEY, SEMICOLON
} from '../../utils/constants';
import './AuditManage.less';

class MeetingAudit extends PureComponent {
  constructor() {
    super();
    this.state = {
      rejectModal: false,
      currentMeeting: {}
    };
  }

  render() {
    const {
      list = [],
      current,
      pageSize,
      total,
      dispatch,
      userInfo,
      intl
    } = this.props;
    const { roleKey } = userInfo;
    const { rejectModal, currentMeeting } = this.state;
    return (
      <div className="audit-manage">
        <Table
          columns={[
            {
              title: (
                <div>{intl.formatMessage({ id: 'meeting_list_table_id' })}</div>
              ),
              width: '15%',
              key: 'meetingNo',
              render: record => {
                return (
                  <div
                    style={{ color: '#4680FF', cursor: 'pointer' }}
                    onClick={() => {
                      const { id, type } = record;
                      dispatch(
                        routerRedux.push(
                          `${PATHS.meetingInfo}?meetingId=${id}&reType=${
                            type > 0 ? 1 : 0
                          }`
                        )
                      );
                    }}
                  >
                    {record.meetingNo}
                  </div>
                );
              }
            },
            {
              title: intl.formatMessage({ id: 'meeting_list_table_subject' }),
              width: '15%',
              key: 'title',
              render: record => {
                let cycleIcon = null;
                if (record.type != 0) {
                  //循环会议
                  cycleIcon = (
                    <Icon style={{ marginLeft: '10px' }} type="retweet" />
                  );
                }
                return (
                  <div className="table-meeting-title">
                    <div title={record.name}>{record.name}</div>
                    {cycleIcon}
                  </div>
                );
              }
            },
            {
              title: (
                <div>
                  {intl.formatMessage({ id: 'meeting_list_table_room' })}
                </div>
              ),
              width: '12%',
              key: 'roomNames',
              render: record => {
                return (
                  <div className="table-meeting-room"><div title={intl.locale === ENGLISH?record.roomNamesEn:record.roomNames}>{intl.locale == ENGLISH?record.roomNamesEn:record.roomNames}</div></div>
                );
              }
            },
            {
              title: (
                <div className="table-item-align">
                  {intl.formatMessage({ id: 'meeting_list_table_start' })}
                </div>
              ),
              width: '12%',
              key: 'showStartTime',
              dataIndex: 'showStartTime',
              render: record => {
                return (
                  <div className="table-item-align">
                    <p>{record.split(' ')[0]}</p>
                    <p>{record.split(' ')[1]}</p>
                  </div>
                );
              }
            },
            {
              title: (
                <div className="table-item-align">
                  {intl.formatMessage({ id: 'meeting_list_table_end' })}
                </div>
              ),
              width: '12%',
              key: 'showEndTime',
              dataIndex: 'showEndTime',
              render: record => {
                return (
                  <div className="table-item-align">
                    <p>{record.split(' ')[0]}</p>
                    <p>{record.split(' ')[1]}</p>
                  </div>
                );
              }
            },
            {
              title: (
                <div>
                  {intl.formatMessage({ id: 'meeting_list_table_creator' })}
                </div>
              ),
              width: '8%',
              key: 'holder',
              render: record => {
                return <div>{record.holder}</div>;
              }
            },
            {
              title: (
                <div>
                  {intl.formatMessage({ id: 'meeting_list_table_status' })}
                </div>
              ),
              width: '12%',
              key: 'status',
              render: record => {
                const { status, roomAudit: auditList = [] } = record;
                const {rejectRemark = "", auditRecord = {}} = this.getRejectInfo(auditList) || {};
                const { status: roomAuditStatus } = auditRecord;
                switch (status) {
                  case MEETING_STATUS.cancel:
                    return (
                      <div className="point-wrapper">
                        <div className="point-cancel" />
                        <FormattedMessage id="re_canceled" />
                      </div>
                    );
                  case MEETING_STATUS.reject:
                    return (
                      <div className="point-wrapper">
                        <div className="point-reject" />
                        <FormattedMessage id="meeting_rejected" />
                        <RejectTip content={rejectRemark}/>
                      </div>
                    );
                  case MEETING_STATUS.audit:
                    if (roomAuditStatus === MEETING_AUDIT_STATUS.audit) {
                      return (
                        <div className="point-wrapper">
                          <div className="point-audit" />
                          <FormattedMessage id="meeting_no_approved" />
                        </div>
                      );
                    } else {
                      return (
                        <div className="point-wrapper">
                          <div className="point-audit" />
                          <FormattedMessage id="meeting_other_no_approved" />
                        </div>
                      );
                    }
                  case MEETING_STATUS.pending:
                    return (
                      <div className="point-wrapper">
                        <div className="point-agree" />
                        <FormattedMessage id="meeting_agree" />
                      </div>
                    );
                  case MEETING_STATUS.opened:
                    return (
                      <div className="point-wrapper">
                        <div className="point-agree" />
                        <FormattedMessage id="meeting_agree" />
                      </div>
                    );
                  case MEETING_STATUS.closed:
                    return (
                      <div className="point-wrapper">
                        <div className="point-agree" />
                        <FormattedMessage id="meeting_agree" />
                      </div>
                    );
                  default:
                    return null;
                }
              }
            }
          ].concat(
            roleKey === ROLES_KEY.room_admin
              ? [
                  {
                    title: intl.formatMessage({
                      id: 'meeting_list_table_operate'
                    }),
                    render: record => {
                      const { status, id, roomAudit: auditList = [] } = record;
                      const {auditRecord} = this.getRejectInfo(auditList) || {}
                      //如果查不到审批记录，说明该会议室管理员没有审批这个会议室的权限
                      if(!auditRecord){
                        return null;
                      }
                      const roomAudit =
                        auditList && auditList.length > 0 && auditList[0]
                          ? auditList[0]
                          : {};
                      const { status: roomAuditStatus } = roomAudit;
                      if (
                        status === MEETING_STATUS.audit &&
                        roomAuditStatus === MEETING_AUDIT_STATUS.audit
                      ) {
                        return (
                          <span>
                            <OperateSpan
                              onClick={this.auditMeeting.bind(this, {
                                meetingId: id,
                                auditStatus: 0
                              })}
                            >
                              {intl.formatMessage({ id: 'btn_approval' })}
                            </OperateSpan>
                            <OperateSpan
                              onClick={() =>
                                this.setState({
                                  rejectModal: true,
                                  currentMeeting: record
                                })
                              }
                            >
                              {intl.formatMessage({ id: 'btn_reject' })}
                            </OperateSpan>
                          </span>
                        );
                      }
                      return null;
                    }
                  }
                ]
              : []
          )}
          dataSource={list}
          rowKey={record => record.id}
          pagination={
            total > pageSize
              ? {
                  total,
                  current,
                  pageSize,
                  onChange: this.onPageChange,
                  onShowSizeChange: this.onPageChange
                }
              : false
          }
        />
        <AuditRejectModal
          visible={rejectModal}
          onClose={() =>
            this.setState({ rejectModal: false, currentMeeting: {} })
          }
          onSubmit={remark => {
            this.auditMeeting({
              meetingId: currentMeeting.id,
              auditStatus: 1,
              remark
            });
          }}
        />
      </div>
    );
  }

  /**
   * 获取会议的审批拒绝信息，如果当前用户是会议室管理员，把该管理员的审批记录也查上来
   * @param meetingAudits
   * @return Object {rejectRemark = "", auditRecord = {}}
   */
  getRejectInfo = (meetingAudits = []) => {
    const { userInfo } = this.props;
    const { userId, roleKey } = userInfo;
    const rejectRecords = meetingAudits.filter(r => r.status === MEETING_AUDIT_STATUS.reject);
    const rejectRemark = rejectRecords.length > 0 ? rejectRecords[0].remark : "";
    if(roleKey === ROLES_KEY.room_admin){
      for(let mAudit of meetingAudits){
        const {userId: roomAdmins = ""} = mAudit;
        if (userId === roomAdmins
          || roomAdmins.startsWith(userId + SEMICOLON)
          || roomAdmins.endsWith(SEMICOLON + userId)
          || roomAdmins.indexOf(SEMICOLON + userId + SEMICOLON) !== -1) {
          return {auditRecord: mAudit, rejectRemark};
        }
      }
    }
    return {rejectRemark}
  };

  auditMeeting = ({ meetingId, auditStatus, remark = '' }) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'meetingAudit/auditMeeting',
      meetingId,
      auditStatus,
      remark
    });
  };

  onPageChange = (current, pageSize) => {
    const { dispatch } = this.props;
    dispatch({ type: 'meetingAudit/update', payload: { current, pageSize } });
    dispatch({ type: 'meetingAudit/getAuditMeetings' });
  };
}



const mapStateToProps = state => {
  return {
    ...state.meetingAudit,
    userInfo: state.login.userInfo
  };
};

export default connect(mapStateToProps)(injectIntl(MeetingAudit));



// WEBPACK FOOTER //
// ./src/routes/AuditManage/MeetingAudit.js